import React from 'react';
import ZcomLogo from './ZcomLogo';

// When the product name appears, for headers that share the row with buttons
// (compact) or with the whole menu as well (compact="wide").
const NAME_FROM = { true: 'hidden sm:inline', wide: 'hidden min-[1100px]:inline' };

/**
 * Brand block of the public pages: the zcom logo, then the product name.
 * `height` is the logo's; the name scales with it. `product={false}` leaves
 * the logo alone. `compact` makes room on narrow screens: a smaller logo on
 * phones and the name only once the row can take it.
 */
export default function BrandLogo({ height = 38, product = true, compact = false, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-2.5 shrink-0 ${className}`}>
      <ZcomLogo height={height} className={`text-[#1a4f8b] ${compact ? 'max-sm:h-[34px] max-sm:w-auto' : ''}`} />
      {product && (
        <span
          className={`${NAME_FROM[compact] || ''} border-l border-[#d5dde5] pl-2.5 font-black tracking-tight text-[#1a4f8b] leading-none`}
          style={{ fontSize: Math.round(height * 0.5) }}
        >
          zBilling
        </span>
      )}
    </span>
  );
}
